import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDependentQueryResponse,
  GetApiDependentQueryParams,
  GetApiDependent401,
  GetApiDependent403,
} from "../../../types/GetApiDependent";

export function getGetApiDependentUrl() {
  return `/api/Dependent` as const;
}

/**
 * {@link /api/Dependent}
 */
export async function getApiDependent(
  params?: GetApiDependentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDependentQueryResponse,
    ResponseErrorConfig<GetApiDependent401 | GetApiDependent403>,
    unknown
  >({
    method: "GET",
    url: getGetApiDependentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
